import { Suspense, useEffect } from "react";
import { useQueryLoader } from "react-relay";

import { Box } from "@whoosh/design-system/src/components/primitive";
import { useTodaysDate } from "@whoosh/utilities/src/dates";

import {
  CurrentClubWeatherInner,
  CurrentClubWeatherInnerQueryString,
} from "./components/CurrentClubWeatherInner";
import { CurrentClubWeatherInnerQuery } from "./components/__generated__/CurrentClubWeatherInnerQuery.graphql";

export const CurrentClubWeather = ({
  showMinimal,
}: {
  showMinimal?: boolean;
}) => {
  const [queryRef, loadQuery] = useQueryLoader<CurrentClubWeatherInnerQuery>(
    CurrentClubWeatherInnerQueryString
  );

  const today = useTodaysDate();

  useEffect(() => {
    loadQuery({ date: today });
  }, [loadQuery, today]);

  return (
    <Suspense fallback={<Box height={20} />}>
      {queryRef ? (
        <CurrentClubWeatherInner
          queryRef={queryRef}
          showMinimal={showMinimal}
        />
      ) : null}
    </Suspense>
  );
};
